export const modelMap: Record<string, string> = {
  "Inp-SA-Score": "Physicochemical Properties",
  "Gen-SA-Score": "Physicochemical Properties",
  "Inp-QED": "Physicochemical Properties",
  "Gen-QED": "Physicochemical Properties",

  "Inp-HIA(Human-Intestinal-Absorption)": "Absorption",
  "Gen-HIA(Human-Intestinal-Absorption)": "Absorption",

  "Inp-VDSS": "Distribution",
  "Gen-VDSS": "Distribution",

  "Inp-Half-Life": "Excretion",
  "Gen-Half-Life": "Excretion",

  "Inp-Hepatotoxicity": "Toxicity",
  "Gen-Hepatotoxicity": "Toxicity",
  "Inp-Cardiotoxicity": "Toxicity",
  "Gen-Cardiotoxicity": "Toxicity",
  "Inp-Carcinogenecity": "Toxicity",
  "Gen-Carcinogenecity": "Toxicity",
  "Inp-Respiratory-toxicity": "Toxicity",
  "Gen-Respiratory-toxicity": "Toxicity",
  "Inp-Mutagenicity": "Toxicity",
  "Gen-Mutagenicity": "Toxicity",
  "Inp-Cytotoxicity": "Toxicity",
  "Gen-Cytotoxicity": "Toxicity",
  "Inp-Lowest-Observed-Adverse-Effect-Level": "Toxicity",
  "Gen-Lowest-Observed-Adverse-Effect-Level": "Toxicity",
};

export const infoModelMap: Record<string, string> = {
  "Inp-VDSS":
    "This metric predicts VDss, measured in\
    liters per kilogram (l/kg). The volume of distribution at steady state is a pharmacokinetic\
    parameter that describes the extent to which a drug distributes into body tissues away\
    from the bloodstream. It helps in understanding how a drug is dispersed in the body and\
    is key to determining dosing regimens. Generally, a larger VDss indicates more extensive\
    distribution into tissues.",

  "Gen-VDSS":
    "This metric predicts VDss, measured in\
    liters per kilogram (l/kg). The volume of distribution at steady state is a pharmacokinetic\
    parameter that describes the extent to which a drug distributes into body tissues away\
    from the bloodstream. It helps in understanding how a drug is dispersed in the body and\
    is key to determining dosing regimens. Generally, a larger VDss indicates more extensive\
    distribution into tissues.",

  "Inp-HIA(Human-Intestinal-Absorption)":
    "This measures the likelihood of a compound being\
    absorbed through the human intestine. High HIA is often necessary for oral\
    effectiveness of drugs. This metric helps in understanding how much of a drug can enter\
    systemic circulation following oral administration.",
  "Gen-HIA(Human-Intestinal-Absorption)":
    "This measures the likelihood of a compound being\
    absorbed through the human intestine. High HIA is often necessary for oral\
    effectiveness of drugs. This metric helps in understanding how much of a drug can enter\
    systemic circulation following oral administration.",

  "Inp-Half-Life":
    "Estimates the half-life of a molecule with units in hours. The half-life is the time\
    it takes for the concentration of the drug in the body to be reduced by half. This is a\
    crucial pharmacokinetic parameter that helps determine the dosing frequency and\
    duration of a drug's effect. A longer half-life means the drug stays in the body for an\
    extended period, which could allow for less frequent dosing.",

  "Gen-Half-Life":
    "Estimates the half-life of a molecule with units in hours. The half-life is the time\
    it takes for the concentration of the drug in the body to be reduced by half. This is a\
    crucial pharmacokinetic parameter that helps determine the dosing frequency and\
    duration of a drug's effect. A longer half-life means the drug stays in the body for an\
    extended period, which could allow for less frequent dosing.",

  "Inp-Hepatotoxicity":
    "This metric predicts the likelihood of a compound being hepatotoxic, or toxic to the liver. The liver is a vital organ for drug metabolism, so hepatotoxicity is a major concern in pharmaceuticals, as it can lead to liver damage or failure.",
  "Gen-Hepatotoxicity":
    "This metric predicts the likelihood of a compound being hepatotoxic, or toxic to the liver. The liver is a vital organ for drug metabolism, so hepatotoxicity is a major concern in pharmaceuticals, as it can lead to liver damage or failure.",

  "Inp-Cardiotoxicity":
    "This metric measures the probability of a compound being cardiotoxic,specifically focusing on hERG blockage (a potassium channel in the heart) with an IC50 cutoff of 10 micromolar. Cardiotoxicity can lead to heart-related adverse effects, making this an important parameter for drugs that may affect cardiovascular health.",
  "Gen-Cardiotoxicity":
    "This metric measures the probability of a compound being cardiotoxic,specifically focusing on hERG blockage (a potassium channel in the heart) with an IC50 cutoff of 10 micromolar. Cardiotoxicity can lead to heart-related adverse effects, making this an important parameter for drugs that may affect cardiovascular health.",
  "Inp-Carcinogenecity":
    "This metric predicts the probability of a molecule being carcinogenic,\
    i.e., having the potential to cause cancer. Carcinogenic compounds can lead to the\
    development of cancerous cells over time, making this a critical safety assessment in\
    drug development.",
  "Gen-Carcinogenecity":
    "This metric predicts the probability of a molecule being carcinogenic,\
    i.e., having the potential to cause cancer. Carcinogenic compounds can lead to the\
    development of cancerous cells over time, making this a critical safety assessment in\
    drug development.",
  "Inp-Respiratory-toxicity":
    "Estimates the probability of a molecule causing respiratory toxicity.Compounds that are toxic to the respiratory system can cause breathing difficulties, lung damage, or other pulmonary issues.",
  "Gen-Respiratory-toxicity":
    "Estimates the probability of a molecule causing respiratory toxicity.Compounds that are toxic to the respiratory system can cause breathing difficulties, lung damage, or other pulmonary issues.",
  "Inp-Mutagenicity":
    "This metric estimates the probability of a molecule being mutagenic,which means it can cause genetic mutations. Mutations can lead to various health problems, including cancer, making this a key parameter for assessing genetic risk.",
  "Gen-Mutagenicity":
    "This metric estimates the probability of a molecule being mutagenic,which means it can cause genetic mutations. Mutations can lead to various health problems, including cancer, making this a key parameter for assessing genetic risk.",
  "Inp-Cytotoxicity":
    "This metric measures the probability of a molecule being cytotoxic, meaning it can be toxic to cells. Assessing cytotoxicity is important for understanding a drug's potential to cause cell damage or death, which can lead to adverse effects in the body.",
  "Gen-Cytotoxicity":
    "This metric measures the probability of a molecule being cytotoxic, meaning it can be toxic to cells. Assessing cytotoxicity is important for understanding a drug's potential to cause cell damage or death, which can lead to adverse effects in the body.",
  "Inp-Lowest-Observed-Adverse-Effect-Level":
    "Lowest concentration or dose of a\
    substance at which there are observable adverse effects in the test subjects. We report\
    the -log10(LOAEL) value, where LOAEL (mg/kg_bw/day) is estimated for rats (subject)\
    assuming the molecule is chronically (>180 days) ingested via oral route.",
  "Gen-Lowest-Observed-Adverse-Effect-Level":
    "Lowest concentration or dose of a\
    substance at which there are observable adverse effects in the test subjects. We report\
    the -log10(LOAEL) value, where LOAEL (mg/kg_bw/day) is estimated for rats (subject)\
    assuming the molecule is chronically (>180 days) ingested via oral route.",

  "Inp-SA-Score":
    "The synthetic accessibility score as a metric for the ease of synthesis",
  "Gen-SA-Score":
    "The synthetic accessibility score as a metric for the ease of synthesis",
  "Inp-QED":
    "Quantitative Estimate of Drug-likeness, a score based on a combination of multiple physicochemical properties",
  "Gen-QED":
    "Quantitative Estimate of Drug-likeness, a score based on a combination of multiple physicochemical properties",
};

export const columnsNumMapping: any = {
  "Gen SA Score": 0,
  "Input SA Score": 1,
  "Gen QED": 2,
  "Input QED": 3,
  "Gen HIA_HOU": 4,
  "Input HIA_HOU": 5,
  "Gen VDSS": 6,
  "Input VDSS": 7,
  "Gen Half-Life": 8,
  "Input Half-Life": 9,
  "Gen Hepatotoxicity": 10,
  "Input Hepatotoxicity": 11,
  "Gen Cardiotoxicity": 12,
  "Input Cardiotoxicity": 13,
  "Input Carcinogenecity": 14,
  "Gen Carcinogenecity": 15,
  "Gen Respiratory Toxicity": 16,
  "Input Respiratory Toxicity": 17,
  "Gen Mutagenicity": 18,
  "Input Mutagenicity": 19,
  "Gen Cytotoxicity": 20,
  "Input Cytotoxicity": 21,
  "Gen Lowest Observed Adverse Effect Level": 22,
  "Input Lowest Observed Adverse Effect Level": 23,
};

export const numColumnMapping: any = {
  0: "Gen-SA-Score",
  1: "Inp-SA-Score",
  2: "Gen-QED",
  3: "Inp-QED",
  4: "Gen-HIA(Human-Intestinal-Absorption)",
  5: "Inp-HIA(Human-Intestinal-Absorption)",
  6: "Gen-VDSS",
  7: "Inp-VDSS",
  8: "Gen-Half-Life",
  9: "Inp-Half-Life",
  10: "Gen-Hepatotoxicity",
  11: "Inp-Hepatotoxicity",
  12: "Gen-Cardiotoxicity",
  13: "Inp-Cardiotoxicity",
  14: "Inp-Carcinogenecity",
  15: "Gen-Carcinogenecity",
  16: "Gen-Respiratory-toxicity",
  17: "Inp-Respiratory-toxicity",
  18: "Gen-Mutagenicity",
  19: "Inp-Mutagenicity",
  20: "Gen-Cytotoxicity",
  21: "Inp-Cytotoxicity",
  22: "Gen-Lowest-Observed-Adverse-Effect-Level",
  23: "Inp-Lowest-Observed-Adverse-Effect-Level",
};
export const columnList = [
  "Gen SA Score",
  "Input SA Score",
  "Gen QED",
  "Input QED",
  "Gen Human Int. Absorption",
  "Input Human Int. Absorption",
  "Gen VDSS",
  "Input VDSS",
  "Gen Half-Life",
  "Input Half-Life",
  "Gen Hepatotoxicity",
  "Input Hepatotoxicity",
  "Gen Cardiotoxicity",
  "Input Cardiotoxicity",
  "Input Carcinogenecity",
  "Gen Carcinogenecity",
  "Gen Respiratory Toxicity",
  "Input Respiratory Toxicity",
  "Gen Mutagenicity",
  "Input Mutagenicity",
  "Gen Cytotoxicity",
  "Input Cytotoxicity",
  "Gen Lowest Observed Adverse Effect Level",
  "Input Lowest Observed Adverse Effect Level",
];

export const fieldsToRound = [
  "Gen-Cardiotoxicity",
  "Gen-HIA(Human-Intestinal-Absorption)",
  "Gen-Half-Life",
  "Gen-Hepatotoxicity",
  "Gen-QED",
  "Gen-SA-Score",
  "Gen-VDSS",
  "Inp-Cardiotoxicity",
  "Tanimoto",
  "Inp-HIA(Human-Intestinal-Absorption)",
  "Inp-Half-Life",
  "Inp-Hepatotoxicity",
  "Inp-QED",
  "Inp-SA-Score",
  "Inp-VDSS",
  "Inp-Human-Int.-Absorption",
  "Gen-Human-Int.-Absorption",
  "Gen-HIA(Human-Intestinal-Absorption)",
  "Inp-HIA(Human-Intestinal-Absorption)",
  "Inp-Carcinogenecity",
  "Gen-Respiratory-toxicity",
  "Inp-Respiratory-toxicity",
  "Gen-Mutagenicity",
  "Inp-Mutagenicity",
  "Gen-Cytotoxicity",
  "Inp-Cytotoxicity",
  "Gen-Lowest-Observed-Adverse-Effect-Level",
  "Inp-Lowest-Observed-Adverse-Effect-Level",
  "Gen-Carcinogenecity",
  "Gen-Clinical-Toxicity",
  "Inp-Clinical-Toxicity",
];
